import DiveDetails from './DiveDetails';

export default DiveDetails;
